import type { LearningLessonDetail } from '../../../services/firebase/learning'
import { resolvePreferredAudioSource } from './audio-source.ts'

interface LearningAudioItem {
  readonly audio?: string | null
  readonly maleAudio?: string | null
}

export function selectPreferredLearningAudio<T extends LearningAudioItem>(
  item: T,
  accentDefault: string | null | undefined,
): T {
  const selectedAudio = resolvePreferredAudioSource({
    card: {
      femaleAudio: item.audio?.trim() || null,
      maleAudio: item.maleAudio?.trim() || null,
    },
    profile: { accent_default: accentDefault },
  })

  return selectedAudio && selectedAudio !== item.audio
    ? { ...item, audio: selectedAudio }
    : item
}

export function selectPreferredLearningLessonDetails(
  blocks: readonly LearningLessonDetail[],
  accentDefault: string | null | undefined,
): LearningLessonDetail[] {
  return blocks.map((block) => ({
    ...selectPreferredLearningAudio(block, accentDefault),
    content: block.content?.map((item) => selectPreferredLearningAudio(item, accentDefault)),
  }))
}
